import React from 'react';
import DatepickerUI from 'react-tailwindcss-datepicker';
import FormLabel from '../FormLabel/FormLabel';

type Props = {
  date: Date;
  placeholder?: string;
  label?: string;
  minDate?: Date;
  required?: boolean;
  onChange: (date: Date) => void;
};

function DatePicker({ date, placeholder, label, minDate, onChange, required }: Props) {
  return (
    <div className="2-full relative z-0 mt-8">
      {label && <FormLabel relative label={label} required={required} name="zzzzz" />}
      <DatepickerUI
        primaryColor="blue"
        value={{
          startDate: date,
          endDate: date
        }}
        asSingle
        placeholder={placeholder}
        minDate={minDate}
        useRange={false}
        onChange={(dateToSet) => {
          const d = new Date(dateToSet?.startDate as string);

          if (d && d.valueOf() > 0) {
            onChange(d);
          } else {
            onChange(new Date());
          }
        }}
        classNames={{
          container: () => 'z-10',
          input: () =>
            'px-0 border-0 border-b-2 border-gray-200 w-full py-2 text-black focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-black focus:outline-none focus:ring-0'
        }}
      />
    </div>
  );
}

export default DatePicker;
